import { render, staticRenderFns } from "./MyChat.vue?vue&type=template&id=01b31f97&"
import script from "./MyChat.vue?vue&type=script&lang=ts&"
export * from "./MyChat.vue?vue&type=script&lang=ts&"
import style0 from "./MyChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
